<template>
  <div class="w-100 px-2 px-md-5 pt-3">
    <course-list :items="items" />
  </div>
</template>

<script>
import Axios from 'axios'
import Courses from './../../components/Course/List'

export default {
  components: {
    'course-list': Courses
  },
  data () {
    return {
      items: []
    }
  },
  methods: {
    loadGroups: function () {
      Axios.get('/course/list')
        .then( res => {
          this.items = res.data.data
        })
        .catch( err => {
          console.error( err )
        })
    }
  },
  mounted () {
    this.loadGroups()
  }
}
</script>

<style>

</style>
